import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

interface TimeRangeFilterProps {
  timeRange: string;
  onTimeRangeChange: (value: string) => void;
}

// Extract time ranges as a reusable constant
const TIME_RANGES = [
  { value: "Today", label: "Today" },
  { value: "Yesterday", label: "Yesterday" },
  { value: "Last Week", label: "Last 7 days" },
  { value: "Last Month", label: "Last 30 days" },
  { value: "180 days", label: "Last 180 days" },
  { value: "CustomizeDate", label: "Custom date" },
];

const TimeRangeFilter: React.FC<TimeRangeFilterProps> = ({
  timeRange,
  onTimeRangeChange,
}) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel className="salon-input-label">Time Range</InputLabel>
      <Select
        className="salon-time-select"
        value={timeRange}
        onChange={(e) => onTimeRangeChange(e.target.value)}
        label="Time Range"
        sx={{ borderRadius: 2 }} // ✅ use MUI sx instead of inline style
      >
        {TIME_RANGES.map(({ value, label }) => (
          <MenuItem key={value} className="salon-menu-item" value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TimeRangeFilter;